'use client'

import textInspirationalTitleXXL from '@fukku/styles/texts/textInspirationalTitleXXL.module.css'
import textInspirationalTitleXXXL from '@fukku/styles/texts/textInspirationalTitleXXXL.module.css'
import cx from 'classix'
import { ServerLabel } from 'labels/components/ServerLabel/ServerLabel'
import { useRef } from 'react'
import { applyStylesIf } from 'utils/applyStylesIf/applyStylesIf'
import { useTextOverflow } from '../../../../../../../hooks/useTextOverflow/useTextOverflow'
import animationStyles from '../../../../MotionAnimations.module.css'
import styles from './HeroBannerShopMultibrandTitle.module.css'

interface HeroBannerShopMultibrandTitleProps {
	readonly titleKey: string
	readonly inverse: boolean
	readonly isLargeOrGreater: boolean
}

export function HeroBannerShopMultibrandTitle({
	titleKey,
	inverse,
	isLargeOrGreater,
}: HeroBannerShopMultibrandTitleProps) {
	const titleRef = useRef(null)
	const isTextOverflowing = useTextOverflow(titleRef)

	const textStyle = cx(
		animationStyles.opacityFadeIn,
		styles.heroBannerShopMultibrandTitle,
		applyStylesIf(inverse, styles.inverse),
		isLargeOrGreater
			? textInspirationalTitleXXXL.className
			: textInspirationalTitleXXL.className,
		applyStylesIf(isTextOverflowing, styles.breakWord)
	)

	return (
		<h2 className={textStyle} ref={titleRef}>
			<ServerLabel
				italicProps={{ className: styles.italic }}
				paragraphProps={{ className: textStyle }}
			>
				{titleKey}
			</ServerLabel>
		</h2>
	)
}
